import React from 'react';
import NumberFormat from 'react-number-format';
import { Field } from 'formik';

export default ({
  name,
  placeholder,
  showErrorMessages = true,
  format,
  maxLength,
  quantityVal,
  onChangeHandler,
  floating = true,
  displayType,
  thousandSeparator,
  decimalScale,
  decimalSeparator,
  fixedDecimalScale,
  allowedDecimalSeparators,
  disabled,
  prefix,
  suffix,
  callBackFlag,
  callBackFun,
  mask,
  quantityLotsMaxValue,
  maxAllowedValueLimit,
  maxQuantity
}) => {
  if (maxLength === undefined) {
    maxLength = 12
  }

  const MAX_VAL = 4000;
  const withValueLimit = (inputObj, name) => {    
    const { value } = inputObj;
    if (value >= 0 && value <= MAX_VAL) return true;

    return false;
  };

  const valueLimitHundred = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 400) return true;

    return false;
  };
  const quantityLotsHundred = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= quantityLotsMaxValue) return true;

    return false;
  };
  const lotsInput = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 10) return true;

    return false;
  };
  const quantityInput = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= quantityVal) return true;

    return false;
  };
  const maxQuantityValue = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= maxQuantity) return true;

    return false;
  };

  

  const valueLimitMonth = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 12) return true;

    return false;
  };

  const commissionValue = (inputObj, name) => {
    const { value } = inputObj;

    if (value >= "99.") {
      return true
    }
    if (value >= 0 && value <= 99) return true;

    return false;
  };


  const withValue = (inputObj) => {
    const { value, floatValue } = inputObj;
    if (name === "endAfterOccurrences") {
      if (value >= 0 && value <= 10) return true;
    } else if (name === 'adminClaimQuality' || name === 'adminClaimQuantity' || name === 'paymentTerm' || name === 'length' || name === 'width' || name === 'height') {
      if (floatValue <= maxAllowedValueLimit || value === '' || !maxAllowedValueLimit) return true;
      else return false
    } else {
      return true;
    }
  };

  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div className='app-input-text number-format-input-styles'>
          <NumberFormat
            autoComplete="off"
            prefix={prefix}
            suffix={suffix}
            placeholder={placeholder}
            format={format}
            fixedDecimalScale={fixedDecimalScale}
            decimalScale={decimalScale}
            displayType={displayType}
            disabled={disabled}
            allowNegative={false}
            thousandSeparator={thousandSeparator}
            allowedDecimalSeparators={allowedDecimalSeparators}
            maxLength={maxLength}
            mask={mask}
            isAllowed={name === "pickupMiles" || name === "distanceWillingToTravel" ? withValueLimit :
              name === "basePrice" || name === "desiredPrice" || name === "cpuPrice" || name === 'bidPrice' || name === 'offerPrice' || name === 'offerAmount' ? valueLimitHundred :
                name === "expMonth" ? valueLimitMonth :
                  (name === "lotsEdit" || name === 'quantityGetQuote' || name === 'quantityPerLot' || name === 'offerQty' || name === 'editRecuurenceQty') ? quantityLotsHundred :
                    name === "quantity" ? quantityInput :
                      name === "lots" ? lotsInput :
                        name === "commissionValue" && !prefix ? commissionValue : maxQuantity?maxQuantityValue:withValue}
            onValueChange={(e) => {
              if (onChangeHandler !== undefined)
                onChangeHandler(e.value)

              if (name === "endAfterOccurrences" || callBackFlag) callBackFun(e.value)
            }}
            name={field.name}
            className={`${meta.touched && meta.error ? 'error' : ''}`}
            {...field}
          />
          {meta.touched && meta.error && showErrorMessages && (
            <p name={name + 'Error'} className='error-message'>{meta.error}</p>
          )}
        </div>
      )}
    </Field>
  );
}
